// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.list-item[data-v-284e6d8e]:hover {\n    background: var(--v-secondary-lighten3) !important;\n}\n.list-item:hover .list-item-text[data-v-284e6d8e] {\n    color: white;\n}\n.v-list--dense .v-list-item[data-v-284e6d8e] {\n    min-height: 20px !important;\n}\n", ""]);
// Exports
module.exports = exports;
